import * as REST from '~services/rest';

export const getMutualReview = async ({ authorId, receiverId }) => {
  if (!authorId || !receiverId) {
    return null;
  }

  try {
    const result = await REST.get({
      name: `reviews`,
      mockFileName: 'reviews/get-by-author',
      params: {
        'author-id': authorId,
      },
    });
    if (result.data.length <= 0) {
      return null;
    }

    return result.data.find((r) => r.receiver_id === receiverId) || null;
  } catch (err) {
    console.log('Error while fetching review', err);
    return null;
  }
};

export const createReview = async ({ authorId, receiverId, score, text, token }) => {
  if (!authorId || !receiverId) {
    return null;
  }

  await REST.post({
    name: `reviews`,
    mockFileName: 'reviews/post-review',
    params: {
      author_id: authorId,
      receiver_id: receiverId,
      score,
      text,
    },
    shouldThrowError: true,
    token,
  });
};

export const updateReview = async ({ reviewId, authorId, receiverId, score, text, token }) => {
  if (!authorId || !receiverId) {
    return null;
  }

  await REST.put({
    name: `reviews`,
    mockFileName: 'reviews/put-review',
    params: {
      id: reviewId,
      author_id: authorId,
      receiver_id: receiverId,
      score,
      text,
    },
    shouldThrowError: true,
    token
  });
};
